import React, { useState } from "react";

const MobileCollegeCard = ({
  college,
  rankKey,
  studentRank,
  statusClass,
  statusText,
  cardBorderClass,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const collegeRank = parseInt(college[rankKey]) || 0;

  return (
    <div
      className={`mb-4 border-2 rounded-xl shadow-sm ${cardBorderClass} overflow-hidden bg-white`}
    >
      <div className="p-4">
        <div className="flex justify-between items-start">
          <div>
            <div className="flex items-center mb-1">
              <span className="text-xs font-semibold bg-gray-100 text-gray-800 px-2 py-0.5 rounded mr-2">
                {college.inst_code}
              </span>
              <span
                className={`px-2 py-0.5 text-xs font-semibold rounded-full ${statusClass}`}
              >
                {statusText}
              </span>
            </div>
            <h3 className="text-sm font-semibold text-gray-900">
              {college.inst_name}
            </h3>
          </div>
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-gray-500 hover:text-blue-600 mt-1"
            aria-expanded={isExpanded}
            aria-label="Toggle details"
          >
            {isExpanded ? (
              <svg
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 15l7-7 7 7"
                />
              </svg>
            ) : (
              <svg
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            )}
          </button>
        </div>

        {/* Basic Info */}
        <div className="flex flex-wrap mt-3 gap-y-2">
          <div className="w-1/2">
            <div className="text-xs text-gray-500">Branch</div>
            <div className="text-xs font-medium">
              <span className="inline-flex items-center px-2 py-0.5 rounded bg-blue-100 text-blue-800">
                {college.branch_code}
              </span>
            </div>
          </div>
          <div className="w-1/2">
            <div className="text-xs text-gray-500">Closing Rank</div>
            <div className="text-sm font-semibold text-gray-900">
              {college[rankKey]}
            </div>
          </div>
        </div>

        {/* Contact Actions */}
        <div className="mt-4 flex justify-between items-center flex-wrap gap-2">
          <div className="flex gap-2">
            {/* {college.contact_number && (
              <a
                href={`tel:${college.contact_number}`}
                className="flex items-center text-xs bg-blue-50 text-blue-700 py-1 px-2 rounded-md"
              >
                <svg
                  className="h-4 w-4 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                Call
              </a>
            )} */}
            {college.website && (
              <a
                href={
                  college.website.startsWith("http")
                    ? college.website
                    : `http://${college.website}`
                }
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-xs bg-blue-50 text-blue-700 py-1 px-2 rounded-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3.5 w-3.5 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3.6 9h16.8M3.6 15h16.8"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 3.6v16.8M16 3.6v16.8"
                  />
                </svg>
                Website
              </a>
            )}
          </div>
          {college.place && (
            <a
              href={
                college.location_links ||
                `https://www.google.com/maps/search/${encodeURIComponent(
                  `${college.inst_name} ${college.place}`
                )}`
              }
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-xs text-gray-700"
            >
              <svg
                className="h-4 w-4 mr-1 text-gray-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17.657 16.657L13.414 20.9a2 2 0 01-2.827 0l-4.243-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              {college.place}
            </a>
          )}
        </div>
      </div>

      {/* Expanded Section */}
      {isExpanded && (
        <div className="px-4 py-3 bg-gray-50 border-t border-gray-200 text-sm">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <div className="text-xs text-gray-500 font-medium">
                College Fee
              </div>
              <div>
                {college.college_fee ? (
                  <span className="font-medium">
                    ₹{college.college_fee.toLocaleString()}
                  </span>
                ) : (
                  <span className="text-gray-400 text-xs">Not available</span>
                )}
              </div>
            </div>

            {college.contact_number && (
              <div>
                <div className="text-xs text-gray-500 font-medium">
                  Contact Number
                </div>
                <div className="truncate">{college.contact_number}</div>
              </div>
            )}

            {college.type && (
              <div>
                <div className="text-xs text-gray-500 font-medium">
                  College Type
                </div>
                <div>{college.type}</div>
              </div>
            )}

            <div>
              <div className="text-xs text-gray-500 font-medium">
                Your Rank Gap
              </div>
              <div>
                {collegeRank > studentRank ? (
                  <span className="text-green-600 font-medium">
                    +{collegeRank - studentRank} ranks
                  </span>
                ) : (
                  <span className="text-red-600 font-medium">
                    -{studentRank - collegeRank} ranks
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileCollegeCard;
